import React from 'react';
import styled from '@emotion/styled';

import { mq, grayBg } from '../../_style';

import ContentWidth from './contentWidth';

const BgContainer = styled.div`
  background-color: ${grayBg};
  ${mq.pc} {
    padding: 120px 0;
    margin-bottom: 120px;
  }
  ${mq.sp} {
    padding: 60px 0;
    margin-bottom: 60px;
  }
`;

const ArticleWrap = (props) => {
  return(
    <BgContainer>
      <ContentWidth>
        {props.children}
      </ContentWidth>
    </BgContainer>
  );
};
export default ArticleWrap;
